<template>
	<div class="bs-left">
		<div class="bs-section bs-section--top">
			<BSBlock class="bsblock" title="存量资产分类统计" fangxiang="left"></BSBlock>
			<div class="bsbox-w">
				<div class="bsbox" style="width:100%">
					<ZCcunliangzichanfenlei @data-click="handleDataClick" />
				</div>
				<!-- 饼图已注释，改为纯卡片展示 -->
				<!-- <div class="bsbox">
					<ZCcunliangzichanfenlei2 @chart-click="handleChartClick" />
				</div> -->
			</div>
		</div>
		<div class="bs-section bs-section--middle">
			<BSBlock class="bsblock" title="存量资产运营分析" fangxiang="left" danwei="处"></BSBlock>
			<div class="bsbox-w">
				<div class="bsbox">
					<ZCzichanchuzulv2 @data-click="handleDataClick" />
				</div>
				<div class="bsbox">
					<ZCcunliangzichanxingzhizhanbi2 @chart-click="handleChartClick" />
				</div>
			</div>
		</div>
		<div class="bs-section bs-section--bottom">
			<BSBlock class="bsblock" title="资产信息轮播表" fangxiang="left" danwei="--"></BSBlock>
			<div class="bsbox-w">
				<div class="bsbox" style="width:100%">
					<ZCguquanzichanchuzifangshiAmount @list-click="handleListClick"/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import BSBlock from "../../components/TitleBlock.vue";
	import ZCcunliangzichanfenlei from "../../views/index/charts/ZCcunliangzichanfenlei.vue"; //存量资产分类
	import ZCcunliangzichanfenlei2 from "../../views/index/charts/ZCcunliangzichanfenlei2.vue"; //存量资产分类
	import ZCzichanchuzulv2 from "../../views/index/charts/ZCzichanchuzulv2.vue"; //资产出租率2（换位至存量资产性质占比）
	import ZCcunliangzichanxingzhizhanbi from "../../views/index/charts/ZCcunliangzichanxingzhizhanbi.vue"; //存量资产性质占比
	import ZCcunliangzichanxingzhizhanbi2 from "../../views/index/charts/ZCcunliangzichanxingzhizhanbi2.vue"; //存量资产性质占比--圆环
	import ZCguquanzichanchuzifangshiAmount from "../../views/index/charts/ZCguquanzichanchuzifangshiAmount.vue"; //资产信息轮播表

	export default {
		components: {
			BSBlock,
			ZCcunliangzichanfenlei,
			ZCcunliangzichanfenlei2,
			ZCzichanchuzulv2,
			ZCcunliangzichanxingzhizhanbi,
			ZCcunliangzichanxingzhizhanbi2,
			ZCguquanzichanchuzifangshiAmount,
		},

		methods: {
			handleChartClick(data) {
				// 将事件传递给父组件（index.vue）
				this.$emit('chart-click', data);
			},
			handleDataClick(data) {
				// 将事件传递给父组件（index.vue）
				this.$emit('data-click', data);
			},
			handleListClick(data) {
				// 将事件传递给父组件（index.vue）
				this.$emit('list-click', data);
			}
		},
	};
</script>

<style lang="scss" scoped>
	.bs-left {
		padding: 10px 0px 20px;
		width: calc(33% - 20px);
		height: calc(100% - 30px);
		margin-right: 20px;
		flex-shrink: 0;
		flex-grow: 0;
		position: relative;
		z-index: 0;
	}

	/* 与右侧 screent_right.vue 保持相同分区高度，确保左右模块对齐 */
	.bs-section--top {
		height: 31%;
	}

	.bs-section--middle {
		height: 31%;
	}

	.bs-section--bottom {
		height: 38%;
	}

	// .bsblock {
	// 	background: linear-gradient(to right, rgb(255 255 255 / 20%) 20%, rgb(255 255 255 / 0%) 100%),
	// }
	.bsbox-w {
		display: flex;
		height: calc(100% - 3vh);
	}

	.bsbox {
		width: 50%;
		height: calc(100% - 0px);
		display: flex;
		align-items: center;
	}
</style>